import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterItem = _resolveComponent("FilterItem")!
  const _component_PageHeaderFilters = _resolveComponent("PageHeaderFilters")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_PageHeaderActions = _resolveComponent("PageHeaderActions")!
  const _component_HopDongTable = _resolveComponent("HopDongTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderFilters, null, {
        default: _withCtx(() => [
          _createVNode(_component_FilterItem, { label: "Loại H/Đồng" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.hopDongType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hopDongType) = $event)),
                clearable: "",
                placeholder: "Trạng thái",
                onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hopDongType = -1))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hopDongTypeOptions, (type) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: type.value,
                      label: type.label,
                      value: type.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_PageHeaderActions, null, {
        default: _withCtx(() => [
          _createVNode(_component_PageHeaderActionItem, { onClick: _ctx.openPrintViewer }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faPrint }, null, 8, ["icon"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Xem danh sách hợp đồng (PDF) ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_HopDongTable, {
        "cur-page": _ctx.currentPage,
        items: _ctx.hopDongItems,
        "per-page": _ctx.perPage
      }, null, 8, ["cur-page", "items", "per-page"]),
      (_ctx.hopDongItems.length > 0)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            page: _ctx.currentPage,
            "page-size": _ctx.perPage,
            total: _ctx.totalItems,
            onChangePage: _cache[2] || (_cache[2] = (value) => (_ctx.currentPage = value)),
            onChangePageSize: _cache[3] || (_cache[3] = (value) => (_ctx.perPage = value))
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}